import { BLAZE_HOME_PATH, CORE_PATH, DOC_PATH, SCHEDULED_POSTS_PATH, SHARED_WITH_ME_DOCS_PATH } from 'paths'
import { generatePath } from 'react-router-dom'
import { ALMANAC_CORE_WORKSPACE_ID } from './constants'

// Extracted as a module-level function so its reference is stable across renders.
// Previously defined inside the hook body, which produced a new function reference
// on every render. Any useEffect listing defaultWorkspacePath as a dependency would
// then re-run on every render — and when combined with useLocation() (which
// re-renders on navigation), this created an infinite navigation loop that blocked
// the JS event loop and caused CI test shards to hang.
export const defaultWorkspacePath = ({
  id,
  guestReader,
  homepageDocSlug,
  promotionCode,
  search,
  goToCalendar = false,
}: {
  id: number
  guestReader?: boolean
  homepageDocSlug: string | null | undefined
  promotionCode?: string
  search?: string
  goToCalendar?: boolean
}) => {
  if (id === ALMANAC_CORE_WORKSPACE_ID) return CORE_PATH

  if (guestReader) {
    return generatePath(SHARED_WITH_ME_DOCS_PATH, { workspaceId: id })
  }

  if (homepageDocSlug) {
    return generatePath(DOC_PATH, { slug: homepageDocSlug })
  }

  let path = generatePath(BLAZE_HOME_PATH, { workspaceId: id, promotion_code: promotionCode })

  if (promotionCode) {
    return `${path}?promotion_code=${promotionCode}${search ? `&${search}` : ''}`
  }

  if (goToCalendar) {
    return generatePath(SCHEDULED_POSTS_PATH, { workspaceId: id })
  }

  return search ? `${path}?${search}` : path
}

// we need to switch recent docs with all files path in january
// after that we can roll back to defaultWorkspacePath
export const useDefaultWorkspacePath = () => {
  return {
    defaultWorkspacePath,
  }
}
